import React, { useState, useEffect } from "react";
import * as services from "../../store/service";
import { getFormattedDate } from "../../util/dateFormatting";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { Notification } from "../common/Notification";

const RssFeedDetails: React.FunctionComponent<{ backToArticles(): void; id: string }> = (props) => {
    const [isLoading, setLoading] = useState(false);
    const [feedDetails, setfeedDetails] = useState({
        title: "",
        link: "",
        creator: "",
        creatorBio: "",
        creatorTitle: "",
        categories: [],
        description: "",
        pubDate: "",
        creatorImage: "",
    });

    useEffect(() => {
        // getRssDetails();
    }, []);

    const getRssDetails = () => {
        if (props.id) {
            setLoading(true);
            services
                .getRSSFeedDetails(props.id)
                .then((data) => {
                    if (data) {
                        setfeedDetails(data);
                        reStyleHtml();
                    }
                })
                .catch(function (error) {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: error,
                        duration: 0,
                    });
                });
        }
    };

    const reStyleHtml = () => {
        setTimeout(() => {
            const bodyHtml = document.getElementById("feed-detail-content");
            if (bodyHtml) {
                const h1Tags = bodyHtml.getElementsByTagName("h1");
                const h1TagList = Array.prototype.slice.call(h1Tags);
                for (let i = 0; i < h1TagList.length; i++) {
                    h1TagList[i].style = "margin: 0.5rem 0 0.5rem 0; text-transform: uppercase;";
                }

                const h2Tags = bodyHtml.getElementsByTagName("h2");
                const h2TagList = Array.prototype.slice.call(h2Tags);
                for (let i = 0; i < h2TagList.length; i++) {
                    h2TagList[i].style = "margin: 0.5rem 0 0.5rem 0; text-transform: uppercase;";
                }

                const h3Tags = bodyHtml.getElementsByTagName("h3");
                const h3TagList = Array.prototype.slice.call(h3Tags);
                for (let i = 0; i < h3TagList.length; i++) {
                    h3TagList[i].style = "margin: 0.3rem 0 0.3rem 0;  text-transform: uppercase;";
                }

                const h4Tags = bodyHtml.getElementsByTagName("h4");
                const h4TagList = Array.prototype.slice.call(h4Tags);
                for (let i = 0; i < h4TagList.length; i++) {
                    h4TagList[i].style = "margin: 0.3rem 0 0.3rem 0;";
                }

                const aTags = bodyHtml.getElementsByTagName("a");
                const aTagList = Array.prototype.slice.call(aTags);
                for (let i = 0; i < aTagList.length; i++) {
                    if (aTagList[i].classList.contains("btn--primary")) {
                        aTagList[i].className = "btn-default btn-primary";
                    } else {
                        aTagList[i].classList.add("default_link");
                    }

                    aTagList[i].target = "_blank";
                    aTagList[i].style = "display: initial;";

                    if (aTagList[i].childElementCount > 0) {
                        for (let j = 0; j < aTagList[i].childElementCount; j++) {
                            if (aTagList[i].childNodes[j].tagName === "IMG") {
                                if (aTagList[i].childNodes[j].classList.contains("alignright")) {
                                    aTagList[i].childNodes[j].style = "float: right;";
                                    aTagList[i].childNodes[j].removeAttribute("height");
                                    aTagList[i].childNodes[j].removeAttribute("width");
                                }
                            }
                        }
                    }
                }

                const tmImg = bodyHtml.getElementsByClassName("wp-smiley");
                const tmImgList = Array.prototype.slice.call(tmImg);
                for (let i = 0; i < tmImgList.length; i++) {
                    const sup = document.createElement("sup");
                    sup.innerText = "TM";
                    tmImgList[i].replaceWith(sup);
                }

                const blockquoteTag = bodyHtml.getElementsByTagName("blockquote");
                const blockquoteTagList = Array.prototype.slice.call(blockquoteTag);
                for (let i = 0; i < blockquoteTagList.length; i++) {
                    blockquoteTagList[i].style = "font-style: italic;border-left: 1px solid #555;color: #555;padding-left: 1em;margin-bottom: 1em;";
                }

                const supTag = bodyHtml.getElementsByTagName("sup");
                const supTagList = Array.prototype.slice.call(supTag);
                for (let i = 0; i < supTagList.length; i++) {
                    supTagList[i].style = "vertical-align: super;font-size: x-small;text-decoration:none;display: inline-block;";
                }

                const emTag = bodyHtml.getElementsByTagName("em");
                const emTagList = Array.prototype.slice.call(emTag);
                for (let i = 0; i < emTagList.length; i++) {
                    emTagList[i].style = "font-style: italic;";
                }

                const ulTags = bodyHtml.getElementsByTagName("ul");
                const ulTagList = Array.prototype.slice.call(ulTags);
                for (let i = 0; i < ulTagList.length; i++) {
                    ulTagList[i].style = "list-style: disc;margin: 0 0 1rem 1rem;padding-left: 2.3rem;line-height: 1.5rem;";
                    const liTags = ulTagList[i].children;
                    if (liTags && liTags.length > 0) {
                        for (let i = 0; i < liTags.length; i++) {
                            liTags[i].style = "padding: 0.3rem;";
                        }
                    }
                }

                const olTags = bodyHtml.getElementsByTagName("ol");
                const olTagList = Array.prototype.slice.call(olTags);
                for (let i = 0; i < olTagList.length; i++) {
                    olTagList[i].style = "list-style: decimal;margin: 0 0 1rem 1rem;padding-left: 2.3rem;line-height: 1.5rem;";
                    const liTags = olTagList[i].children;
                    if (liTags && liTags.length > 0) {
                        for (let i = 0; i < liTags.length; i++) {
                            liTags[i].style = "padding: 0.3rem;";
                        }
                    }
                }
            }

            setLoading(false);
        }, 500);
    };

    return (
        <React.Fragment>
            <div className=" row">
                <div className="col-xs-12">
                    <div tabIndex={-1} className="inline row">
                        <div className=" btn-default btn-primary result-back-arrow-box">
                            <em className="las la-angle-left breach-back-arrow-icon"></em>
                        </div>
                        <a
                            href="javascript:void(0);"
                            className="default_link margin-left-xs margin-top-xs"
                            style={{ fontSize: "1rem" }}
                            onClick={props.backToArticles}
                        >
                            Back to all articles
                        </a>
                    </div>
                </div>
            </div>

            <div className="row" id="content">
                 <div className="col-xs col-no-gutter">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12">
                            <embed type="text/html" src={props.id.replace(".html", "")} width={"100%"} height={"500px"}></embed>
                            {/*<div className={isLoading ? "box loading" : "box"}>
                                {feedDetails.title && (
                                    <div className="box-header">
                                        <h3 className="content-sub-title margin-bottom-xs">{feedDetails.title}</h3>
                                        <div className="box-title-container">
                                            <div className="box-title-text" style={{ backgroundColor: "#ededed", padding: "10px", width: "100%" }}>
                                                <p className="box-title">
                                                    Posted on {getFormattedDate(i18nService.get("Country"), feedDetails.pubDate)}{" "}
                                                    {feedDetails && feedDetails.creatorTitle && (
                                                        <span>
                                                            by <strong>{feedDetails.creatorTitle}</strong>
                                                        </span>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="box-content">
                                    <div
                                        id="feed-detail-content"
                                        className="box-title-container"
                                        dangerouslySetInnerHTML={{ __html: feedDetails.description }}
                                    ></div>
                                </div>
                            </div>
                        </div>
                         <div className="col-xs-12 col-sm-4">
                            <div className="box box-border-top">
                                <div className="box-header">
                                    <div className="box-title-container">
                                        <div className="box-title-text">
                                            <h3 className="box-title">MEET THE AUTHOR</h3>
                                        </div>
                                    </div>
                                </div>
                                {feedDetails.creatorBio && (
                                    <div role="option" className={isLoading ? "box-content loading" : "box-content"}>
                                        <img style={{ borderRadius: "50%" }} height="100px" width="100px" src={feedDetails?.creatorImage} alt="Author Portrait" />
                                        <h4>{feedDetails.creatorTitle}</h4>
                                        <br />
                                        <p>{feedDetails.creatorBio}</p>
                                    </div>
                                )}
                            </div>*/}
                        </div> 
                    </div>
                </div> 
            </div>
        </React.Fragment>
    );
};

export default RssFeedDetails;
